import Service from "../../AuthService";
const MachineProduct = {
    getMachineProduct(page) {
        return Service.get("/machine-product?page="+page);
    },
    showMachineProduct(id) {
        return Service.get("/machine-product/" + id);
    },
    updateMachineProduct(id, data) {
        return Service.put("/machine-product/" + id, data);
    },
    createMachineProduct(data) {
        return Service.post("/machine-product", data);
    },
    deleteMachineProduct(id) {
        return Service.delete("/machine-product/" + id);
    },
};
export default MachineProduct;
